import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { SiteContentProvider } from "@/lib/useSiteContent";
import PrivacyPolicy from "@/components/site/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <SiteContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </BrowserRouter>
      </SiteContentProvider>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1D1D1F",
            color: "#FAFAF8",
            border: "1px solid rgba(182, 141, 64, 0.35)",
            borderRadius: "0px",
            fontFamily: "Manrope, sans-serif",
            fontSize: "0.85rem",
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

export default App;
